import React, { useState, useEffect } from 'react';
import { postsAPI } from '../services/api';
import { FileText, Save, Pencil, TrendingUp } from 'lucide-react';

const Dashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        try {
            const response = await postsAPI.getDashboardStats();
            
            let s = response?.data || {};

            const allZero = !s || (
                Number(s.total_posts || 0) === 0 &&
                Number(s.saved_posts || 0) === 0 &&
                Number(s.draft_posts || 0) === 0 &&
                Number(s.published_posts || 0) === 0
            );

            if (allZero) {
                try {
                    const postsResp = await postsAPI.getAllPosts({ page: 1, limit: 1000 });
                    const posts = postsResp?.data?.posts || [];
                    const total = Number(postsResp?.data?.pagination?.total || posts.length || 0);
                    const draft = posts.filter(p => (p.wp_status === 'draft')).length;
                    const published = posts.filter(p => (p.wp_status === 'publish' || p.wp_status === 'published')).length;
                    const saved = posts.filter(p => (p.wp_status === 'none' || !p.wp_status)).length;
                    s = {
                        total_posts: total,
                        saved_posts: saved,
                        draft_posts: draft,
                        published_posts: published
                    };
                } catch (e) {
                    console.error('Falha no fallback de estatísticas via listagem de posts:', e);
                }
            }

            setStats(s);
        } catch (error) {
            console.error('Erro ao carregar estatísticas:', error);
            // Fallback na falha do endpoint: computa a partir da listagem de posts
            try {
                const postsResp = await postsAPI.getAllPosts({ page: 1, limit: 1000 });
                const posts = postsResp?.data?.posts || [];
                const total = Number(postsResp?.data?.pagination?.total || posts.length || 0);
                const draft = posts.filter(p => (p.wp_status === 'draft')).length;
                const published = posts.filter(p => (p.wp_status === 'publish' || p.wp_status === 'published')).length;
                const saved = posts.filter(p => (p.wp_status === 'none' || !p.wp_status)).length;
                setStats({
                    total_posts: total,
                    saved_posts: saved,
                    draft_posts: draft,
                    published_posts: published
                });
            } catch (e) {
                console.error('Falha no fallback de estatísticas via listagem de posts (erro):', e);
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="dashboard-loading">
                <div className="loading-spinner"></div>
                <p>Carregando estatísticas...</p>
            </div>
        );
    }

    return (
        <div className="dashboard">
            <div className="dashboard-header">
                <h2>📊 Dashboard</h2>
                <p>Visão geral do seu blog</p>
            </div>
            
            <div className="stats-grid">
                <div className="stat-card total-posts">
                    <div className="stat-icon">
                        <FileText size={24} />
                    </div>
                    <div className="stat-content">
                        <h3>{stats?.total_posts || 0}</h3>
                        <p>Total de Posts</p>
                    </div>
                </div>

                <div className="stat-card saved-posts">
                    <div className="stat-icon">
                        <Save size={24} />
                    </div>
                    <div className="stat-content">
                        <h3>{stats?.saved_posts || 0}</h3>
                        <p>Posts Salvos</p>
                    </div>
                </div>

                <div className="stat-card draft-posts">
                    <div className="stat-icon">
                        <Pencil size={24} />
                    </div>
                    <div className="stat-content">
                        <h3>{stats?.draft_posts || 0}</h3>
                        <p>Posts em Rascunho</p>
                    </div>
                </div>

                <div className="stat-card published-posts">
                    <div className="stat-icon">
                        <TrendingUp size={24} />
                    </div>
                    <div className="stat-content">
                        <h3>{stats?.published_posts || 0}</h3>
                        <p>Posts Publicados</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;